export default __webpack_public_path__ + "static/media/enlargeWhite.9e476a40.svg";